import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as groupedProductsForSomeoneElseState from '../employee-detail.reducer';
import * as groupedProductsForSomeoneElseReducer from '../reducers/grouped-products-for-someone-else.reducer';

export const getGroupedProductsForSomeoneElse = createSelector(
  groupedProductsForSomeoneElseState.getGroupedProductsForSomeoneElseState,
  groupedProductsForSomeoneElseReducer.getGroupedProductsForSomeoneElseResponse
);
